import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { Dialog } from "primereact/dialog";
import Langs, { Localize } from "../../app/lang/langs";
import { completeVitalEmail, showErrorToast, showSuccessToast, validateEmail } from "../../app/utils/helpers";
import { addCollab, civiliteOptions, getAllCollabs } from "../../components/collabs/collabsSlice";
import { uploadAsset } from "../../assets/assetsSlice";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import moment from "moment";
import { ConfirmModal } from "../../components/popups/ConfirmModal";
import { InlineCompletionField } from "../../components/inputs/InlineCompletionField";

export default function AddExterneModal(props) {

    const dispatch = useDispatch()

    const subcontractors = useSelector((state) => state.clients.subcontractors)
    const [showConfirmAddDuplicate, setShowConfirmAddDuplicate] = useState(null)
    const [formData, setFormData] = useState({})
    const [files, setFiles] = useState([])
    const [errors, setErrors] = useState({})


    const handleChange = (name, value) => {
        if (name == "sortie_date" && value) {
            value = moment(value).endOf("day").toDate()
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleFileUpload = (e) => {
        setFiles(e.target.files);
    }

    const validateForm = () => {
        const mandatoryFields = [
            "id_subcontractor",
            "title",
            "email",
            "nom",
            "prenom",
            //"date_naissance",
            "mobile_number",
            //"telephone_number",
            "title",
            "postal_code",
            "city",
            "entree_date",
            //"date_debut_cp",
            //"date_fin_cp"
        ]

        const newErrors = {}
        for (let i = 0; i < mandatoryFields.length; i++) {
            if (!formData[mandatoryFields[i]]) newErrors[mandatoryFields[i]] = true
        }
        if (formData.email_perso && !validateEmail(formData.email_perso)) newErrors.email_perso = true
        if (!validateEmail(formData.email)) newErrors.email = true
        console.log("newErrors", newErrors)
        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = (confirmDuplicate) => {

        if (!validateForm()) {
            return showErrorToast(Localize("Veuillez remplir tous les champs obligatoires."))
        }
        try {
            if (confirmDuplicate) {
                formData.confirm_duplicate = true
            }
            dispatch(addCollab(formData)).then(
                (actionResponse) => {
                    if (addCollab.fulfilled.match(actionResponse)) {
                        if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                            if (actionResponse.payload.responseData.status == 2) {
                                return showErrorToast(Localize(`Email`) + ` ${formData.email} ` + Localize(`déjà existant`))
                            }
                            if (actionResponse.payload.responseData.status == 3) {
                                setShowConfirmAddDuplicate(actionResponse.payload.responseData.collabs)
                                return
                            }
                            setShowConfirmAddDuplicate(false)
                            let idCollab = actionResponse.payload.responseData.insert_id
                            Array.from(files).map((file) =>
                                dispatch(
                                    uploadAsset({
                                        tableName: 'collabs',
                                        idParent: idCollab,
                                        filename: file.name,
                                        file
                                    })
                                )
                            )
                            showSuccessToast(Localize("Collaborateur ajouté avec succès."))
                            setFormData({})
                            setFiles([])
                            props.onHide()
                            dispatch(getAllCollabs())
                        }
                    }
                })
        } catch (error) {
            showErrorToast(Localize("Erreur lors de l'ajout du collaborateur."))
        }
    }

    function handleAddDuplicateCollab() {
        handleSubmit(true)
    }

    const isFormValid = () => {

        const requiredFields = [
            "id_subcontractor",
            "nom",
            "prenom",
            "title",
            "email",
            "entree_date",
            //"date_naissance",
            "city",
            "postal_code",
            "mobile_number",
        ]

        for (const field of requiredFields) {
            const value = formData[field];
            if (typeof value === "string" && value.trim() === "") return false
            if (value === null || value === undefined) return false
        }
        return true
    }

    const header = () => {
        return <h5 className="mb-3 p-3"><Langs str="ADD_EXTERNE" /></h5>
    }

    const footer = () => {
        return <div className="d-flex align-items-center p-3">
            <Col sm={2} className="d-flex justify-content-center">
                <PrimaryButton
                    title="CANCEL"
                    active={true}
                    onClick={() => {
                        props.onHide()
                        setFormData({})
                        setFiles([])
                    }}
                />
            </Col>
            <Col sm={8} />
            <Col sm={2} className="d-flex justify-content-center">
                <PrimaryButton
                    title="ADD"
                    active={true}
                    onClick={() => handleSubmit()}
                />
            </Col>
        </div>
    }

    return (
        <Dialog
            header={header()}
            footer={footer}
            visible={props.visible}
            modal
            onHide={() => {
                props.onHide()
                setFormData({})
                setFiles([])
            }}
            draggable={false}
            resizable={false}
        >
            <div className="p-fluid p-3"
                style={{ width: "50vw", maxHeight: "65vh" }}
            >
                <Row className="mt-3">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="Subcontractor" /></label>
                    </Col>
                    <Col md={8}>
                        <Dropdown
                            options={subcontractors?.map((subcontractor) => ({
                                label: subcontractor.name,
                                value: subcontractor.id,
                            }))}
                            filter
                            value={formData.id_subcontractor}
                            onChange={(option) => handleChange("id_subcontractor", option.value)}
                            placeholder={Localize("Subcontractor")}
                            required={errors["id_subcontractor"]}
                        />
                    </Col>
                </Row>
                <Row className="mt-3" key="date_naissance">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="DATE_NAISSANCE" /></label>
                    </Col>
                    <Col md={8}>
                        <Calendar
                            showIcon
                            placeholder="DD/MM/YYYY"
                            value={formData["date_naissance"]}
                            onChange={(e) => handleChange("date_naissance", e.value)}
                            invalid={errors["date_naissance"]}
                            maxDate={new Date()}
                            dateFormat="dd/mm/yy"
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="CIVILITY" /></label>
                    </Col>
                    <Col md={8}>
                        <Dropdown
                            options={civiliteOptions}
                            value={formData.title}
                            onChange={(option) => handleChange("title", option.value)}
                            placeholder={Localize("Title")}
                            required={errors["title"]}
                        />
                    </Col>
                </Row>
                {[
                    { label: "FAMILY_NAME", name: "nom", placeholder: "Nom" },
                    { label: "NAME", name: "prenom", placeholder: "Prénom" },
                    { label: "CITY", name: "city", placeholder: "Ville" },
                    { label: "CODE_POSTAL", name: "postal_code", placeholder: "Code postale" },
                    { label: "EMAIL", name: "email", placeholder: "example@groupe-vital.com", completeDomain: true },
                    { label: "EMAIL_PERSO", name: "email_perso", placeholder: "example@domain.com" },
                    { label: "TEL_FIXE", name: "telephone_number", placeholder: "Tel" },
                    { label: "MOBILE_NUMBER", name: "mobile_number", placeholder: "Mobile" },
                ].map((field) => {
                    const input = (
                        <InputText
                            name={field.name}
                            value={formData[field.name]}
                            onChange={(e) => handleChange(field.name, e.target.value)}
                            maxLength={255}
                            className="w-100"
                            invalid={errors[field.name]}
                            placeholder={field.placeholder}
                        />
                    )
                    return (
                        <Row className="mt-3" key={field.name}>
                            <Col md={4} className="fw-bold">
                                <label><Langs str={field.label} /></label>
                            </Col>
                            <Col md={8}>
                                {/* the Vital address only needs its local part typed:
                                    the domain is offered as ghost text, Tab accepts it */}
                                {field.completeDomain ? (
                                    <InlineCompletionField
                                        value={formData[field.name]}
                                        completion={completeVitalEmail(formData[field.name])}
                                        onAccept={(completed) => handleChange(field.name, completed)}
                                    >
                                        {input}
                                    </InlineCompletionField>
                                ) : input}
                            </Col>
                        </Row>
                    )
                })}
                <Row className="mt-3" key="entree_date">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="ENTRY_DATE" /></label>
                    </Col>
                    <Col md={8}>
                        <Calendar
                            showIcon
                            placeholder="DD/MM/YYYY"
                            value={formData["entree_date"]}
                            onChange={(e) => handleChange("entree_date", e.value)}
                            dateFormat="dd/mm/yy"
                            invalid={errors["entree_date"]}
                        />
                    </Col>
                </Row>
                <Row className="mt-3" key="sortie_date">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="SORTIE_DATE" /></label>
                    </Col>
                    <Col md={8}>
                        <Calendar
                            showIcon
                            placeholder="DD/MM/YYYY"
                            value={formData["sortie_date"]}
                            onChange={(e) => handleChange("sortie_date", e.value)}
                            invalid={errors["sortie_date"]}
                            disabled={!formData["entree_date"]}
                            minDate={formData["entree_date"]}
                            dateFormat="dd/mm/yy"
                        />
                    </Col>
                </Row>
                <Row className="mt-3" key="date_debut_cp">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="Date début CP" /></label>
                    </Col>
                    <Col md={8}>
                        <Calendar
                            showIcon
                            placeholder="DD/MM/YYYY"
                            value={formData["date_debut_cp"]}
                            onChange={(e) => handleChange("date_debut_cp", e.value)}
                            invalid={errors["date_debut_cp"]}
                            dateFormat="dd/mm/yy"
                        />
                    </Col>
                </Row>
                <Row className="mt-3" key="date_fin_cp">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="Date fin CP" /></label>
                    </Col>
                    <Col md={8}>
                        <Calendar
                            showIcon
                            placeholder="DD/MM/YYYY"
                            value={formData["date_fin_cp"]}
                            onChange={(e) => handleChange("date_fin_cp", e.value)}
                            invalid={errors["date_fin_cp"]}
                            disabled={!formData["date_debut_cp"]}
                            minDate={formData["date_debut_cp"]}
                            dateFormat="dd/mm/yy"
                        />
                    </Col>
                </Row>
                <Row className="mt-3" key="date_fin_cp">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="TJM achat" /></label>
                    </Col>
                    <Col md={8}>
                        <InputNumber
                            showIcon
                            placeholder="0000"
                            value={formData["tjm_achat"]}
                            onChange={(e) => handleChange("tjm_achat", e.value)}
                            min={0}
                            dateFormat="dd/mm/yy"
                        />
                    </Col>
                </Row>
                <Row className="mt-3" key="date_fin_cp">
                    <Col md={4} className="fw-bold">
                        <label><Langs str="TJM vente" /></label>
                    </Col>
                    <Col md={8}>
                        <InputNumber
                            showIcon
                            placeholder="0000"
                            value={formData["tjm_vente"]}
                            onChange={(e) => handleChange("tjm_vente", e.value)}
                            min={0}
                            dateFormat="dd/mm/yy"
                        />
                    </Col>
                </Row>
                <Row className="py-3">
                    <Col lg={4} className="fw-bold">
                        <label ><Langs str="UPLOAD_FILES" /></label>
                    </Col>
                    <Col lg={8}>
                        <input
                            type="file"
                            multiple
                            onChange={handleFileUpload}
                            className="form-control"
                        />
                    </Col>
                </Row>
            </div>
            <ConfirmModal
                show={Boolean(showConfirmAddDuplicate)}
                title={<Langs str='ADD_DUPLICATE_COLLAB' />}
                message={<p>
                    <Langs str="ADD_DUPLICATE_COLLAB_MSG" params={{count: showConfirmAddDuplicate?.length}}/><br/><br/>
                    <p className="error">{showConfirmAddDuplicate ? showConfirmAddDuplicate.map(c=> <span>{c}<br/></span> ) : ""}</p>
                </p>}
                onConfirm={() => handleAddDuplicateCollab()}
                onHide={() => setShowConfirmAddDuplicate(null)}
            />
        </Dialog>
    )
}
